var NumberSystems = {
    Kanji: {
        Numerals: {
            0: '零',
            1: '一',
            2: '二',
            3: '三',
            4: '四',
            5: '五',
            6: '六',
            7: '七',
            8: '八',
            9: '九',
            10: '十',
            100: '百',
            1000: '千',
            10000: '万',
            100000000: '億',
            1000000000000: '兆',
        },
        Minus: 'マイナス',
        Point: '点',
    },
    Hiragana: {
        Numerals: {
            0: 'ぜろ',
            1: 'いち',
            2: 'に',
            3: 'さん',
            4: 'よん',
            5: 'ご',
            6: 'ろく',
            7: 'なな',
            8: 'はち',
            9: 'きゅう',
            10: 'じゅう',
            100: 'ひゃく',
            1000: 'せん',
            10000: 'まん',
            100000000: 'おく',
            1000000000000: 'ちょう',
        },
        Minus: 'まいなす',
        Point: 'てん',
        Exceptions: {
            300: 'さんびゃく',
            600: 'ろっぴゃく',
            800: 'はっぴゃく',
            3000: 'さんぜん',
            8000: 'はっせん',
        },
    },
    Katakana: {
        Numerals: {
            0: 'ゼロ',
            1: 'イチ',
            2: 'ニ',
            3: 'サン',
            4: 'ヨン',
            5: 'ゴ',
            6: 'ロク',
            7: 'ナナ',
            8: 'ハチ',
            9: 'キュウ',
            10: 'ジュウ',
            100: 'ヒャク',
            1000: 'セン',
            10000: 'マン',
            100000000: 'オク',
            1000000000000: 'チョウ',
        },
        Minus: 'マイナス',
        Point: 'テン',
        Exceptions: {
            300: 'サンビャク',
            600: 'ロッピャク',
            800: 'ハッピャク',
            3000: 'サンゼン',
            8000: 'ハッセン',
        },
    },
    Hepburn: {
        Numerals: {
            0: 'zero',
            1: 'ichi',
            2: 'ni',
            3: 'san',
            4: 'yon',
            5: 'go',
            6: 'roku',
            7: 'nana',
            8: 'hachi',
            9: 'kyuu',
            10: 'juu',
            100: 'hyaku',
            1000: 'sen',
            10000: 'man',
            100000000: 'oku',
            1000000000000: 'chou',
        },
        Minus: 'mainasu',
        Point: 'ten',
        Exceptions: {
            300: 'sanbyaku',
            600: 'roppyaku',
            800: 'happyaku',
            3000: 'sanzen',
            8000: 'hassen',
        },
    },
};

function hashKeys(obj) {
    var keys = [];
    for (var key in obj) {
        if (!obj.hasOwnProperty(key)) {
            continue;
        }
        keys.push(key);
    }
    return keys;
}

function hashKeysNumerical(obj) {
    var keys = hashKeys(obj);
    keys = keys.map(function (numeral) {
        return +numeral;
    });
    keys = keys.sort(function (a, b) {
        return a - b;
    });
    return keys;
}

function findClosestNumeral(numerals, number) {
    var key;

    const keys = hashKeysNumerical(numerals);
    for (var i = keys.length - 1; i >= 0; i--) {
        key = keys[i];
        if (key <= number) {
            break;
        }
    }
    return key;
}

function findException(exceptions, number) {
    if (exceptions) {
        return exceptions[number];
    } else {
        return undefined;
    }
}

function Convert(numerals, minus, point, exceptions, number) {
    var result = '';
    var closest = findClosestNumeral(numerals, number);
    if (closest === number) {
        result += numerals[closest];
        return result;
    }
    var multiple = 1;
    while ((multiple + 1) * closest <= number) multiple++;

    var sub = closest * multiple;
    number -= sub;
    var exception = findException(exceptions, sub);
    if (exception) {
        result += exception;
    } else if (1 != multiple) {
        result += Convert(numerals, minus, point, exceptions, multiple);
    }

    if (!exception) {
        result += numerals[closest];
    }

    if (0 != number) {
        result += ' ';
        result += Convert(numerals, minus, point, exceptions, number);
    }
    return result;
}

export function toJapaneseNumber(number: number, system: keyof typeof NumberSystems = 'Kanji') {
    if (!NumberSystems[system]) return 'Unsupported number system';

    var snumber = number.toString();
    number = +number;
    if (isNaN(number)) return 'Input is not numeric';

    var result = '';

    var sys = NumberSystems[system];
    var numerals = sys['Numerals'];
    var minus = sys['Minus'];
    var point = sys['Point'];
    var exceptions = sys['Exceptions'];

    if (number < 0) result = minus + ' ';

    number = Math.abs(number);
    var decimal = snumber.indexOf('.');
    if (decimal != -1) {
        var first = snumber.substring(0, decimal);
        var second = snumber.substring(decimal + 1);
        result += Convert(numerals, minus, point, exceptions, Math.abs(+first));
        result += ' ' + point + ' ';
        for (let i = 0; i < second.length; i += 1) {
            var digit = +second.substring(i, i + 1);
            result += Convert(numerals, minus, point, exceptions, digit);
            result += ' ';
        }
        result = result.trim();
    } else {
        result += Convert(numerals, minus, point, exceptions, Math.abs(number));
    }

    return result;
}
